<template>
	<IntAnchorOffset :id="anchorId"></IntAnchorOffset>

	<IntContentGrid :columns="{ default: 1, md: 12 }">
		<IntGridColumn v-if="showOverview" :span="{ default: 1, md: 12 }">
			<IntOverview
				:group="group"
				:initial-page-number="query.pageNumber"
				:initial-page-size="query.pageSize"
				:initial-total="totalCount"
			>
			</IntOverview>
		</IntGridColumn>

		<IntGridColumn v-if="hasFilters" :span="{ default: 1, md: 3 }">
			<IntFilters
				:selection-criteria="selectionCriteria"
				:initial-filters="filters"
				:group="group"
			></IntFilters>
		</IntGridColumn>

		<IntGridColumn :span="{ default: 1, md: hasFilters ? 9 : 12 }" class="relative">
			<IntDisplay
				:initial-query="query"
				:initial-items="items"
				:fetch-url="url"
				:fetch-on-load="fetchOnLoad"
				pagination-type="pagination"
				pre-search-label=""
				:anchor-id="anchorId"
				:group="group"
			>
				<template v-slot="{ items }">
					<IntContentGrid
						:columns="{ default: 2, md: hasFilters ? 3 : 4 }"
						:class="[{ 'opacity-50': loading }]"
					>
						<IntGridColumn
							v-for="item in items"
							:key="'product-listing-item=' + item.id"
							:span="1"
						>
							<IntProductTile
								:link="item.link"
								:image="item.image"
								:name="item.name"
								:options-count="item.optionsCount"
							>
								<IntWishlistActions
									v-if="item.productIds.length > 0"
									:product-ids="item.productIds"
									:collection-id="item.optionsCount > 0 ? item.id : 0"
									position-classes="right-3 top-3"
								>
								</IntWishlistActions>

								<template #content v-if="!!item.content">
									<span v-html="item.content"></span>
								</template>
							</IntProductTile>
						</IntGridColumn>
					</IntContentGrid>
				</template>
			</IntDisplay>

			<IntPagination
				v-if="showPagination"
				:initial-page-number="pageNumber"
				:initial-item-count="totalCount"
				:initial-page-size="query.pageSize"
				:group="group"
				:selection-criteria="selectionCriteria"
				:initial-filters="filters"
			>
			</IntPagination>
		</IntGridColumn>

		<IntGridColumn
			v-if="!hasFilters && !showPagination && allItemsProductIds.length > 0"
			:span="{ default: 1, md: 12 }"
		>
			<div class="my-8 text-center">
				<IntWishlistButton :collection-id="query.nodeId" :product-ids="allItemsProductIds">
					Add/remove full range
				</IntWishlistButton>
			</div>
		</IntGridColumn>
	</IntContentGrid>
</template>

<script>
import Base from "./modules/base.js"
import EventBus from "../../bus"
import Events from "../search/events.js"

import IntAnchorOffset from "../anchor-offset"
import IntContentGrid from "../content-grid"
import IntDisplay from "../news-listing/modules/display"
import IntFilters from "./modules/filters/index.vue"
import IntGridColumn from "../content-grid/grid-column.vue"
import IntOverview from "./modules/overview/index.vue"
import IntPagination from "./modules/pagination/index.vue"
import IntProductTile from "../product-tile"
import IntWishlistActions from "../wishlist-actions/index.vue"
import IntWishlistButton from "../wishlists/modules/button/index.vue"

export default {
	name: "IntProductListing",

	mixins: [Base],

	components: {
		IntAnchorOffset,
		IntContentGrid,
		IntDisplay,
		IntFilters,
		IntGridColumn,
		IntOverview,
		IntPagination,
		IntProductTile,
		IntWishlistActions,
		IntWishlistButton,
	},

	props: {
		url: { type: String, required: true },
		query: { type: Object, required: true },
		selectionCriteria: { type: String, required: true },
		items: { type: Array, default: [] },
		totalCount: { type: Number, default: 0 },
		filters: { type: Array, default: [] },
		anchorId: { type: String, default: "product-listing-anchor-id" },
		showOverview: { type: Boolean },
		showPagination: { type: Boolean },
	},

	data() {
		return {
			pageNumber: this.query.pageNumber || 1,
			fetchOnLoad: this.query.fetchOnLoad,
			loading: false,
			hasFilters:
				this.filters &&
				this.filters.some(
					(filter) =>
						filter.display === true && filter.options && filter.options.length > 0,
				),
		}
	},

	computed: {
		allItemsProductIds() {
			if (this.items.length === 0) return []

			let allProductIds = []

			this.items.forEach((item) => {
				allProductIds = allProductIds.concat(item.productIds)
			})

			return allProductIds
		},
	},

	created() {
		EventBus.$on(Events.statusUpdated, this.onStatusUpdatedEvent)
	},

	methods: {
		onStatusUpdatedEvent(e) {
			this.loading = e === "loading"
		},
	},
}
</script>
